export class Severity {
  private static _values: Severity[] = [];
  private static _lookup: Map<number, Severity> = new Map();

  static fromId(id: number) {
    const instance = Severity._lookup.get(id);
    if (instance === undefined) {
      throw new Error('Not a valid Severity.id: ' + id);
    }
    return instance;
  }

  static values(): Severity[] {
    return [...Severity._values];
  }

  // ---

  public readonly id: number;
  public readonly label: string;

  constructor(id: number, label: string) {
    this.id = id;
    this.label = label;
    Severity._values.push(this);
    Severity._lookup.set(id, this);
  }

  toJson(): { id: number; name: string } {
    return { id: this.id, name: this.label };
  }

  toString(): string {
    return '<Severity: ' + this.id + ", label='" + this.label + "'>";
  }
}
